import { Flex, FormItemsGroup, Space, Spacing } from '@billy/design-system'

import { useInvoiceLinesColumns } from '../../hooks/useInvoiceLinesColumns'
import { InvoiceLinesHeaderColumn } from './elements/InvoiceLinesHeaderColumn'

export const InvoiceLinesHeader = () => {
  const { columns, columnItemsTemplate } = useInvoiceLinesColumns()

  return (
    <Flex>
      <FormItemsGroup itemsInRow={columnItemsTemplate.length} itemsTemplate={columnItemsTemplate} spacing={Spacing.S4}>
        {columns.map((column, index) => (
          <InvoiceLinesHeaderColumn column={column} key={`${column}${index}`} />
        ))}
      </FormItemsGroup>
      <Space horizontal size="s8" /> {/* accounts for the spacing between the fields and the button */}
      <Space horizontal size="s40" /> {/* accounts for the remove button */}
    </Flex>
  )
}
